import { API_CONFIG } from '../config/api';

export const API_BASE = API_CONFIG.baseURL;
export const DISCOVERY_API_BASE = API_CONFIG.discoveryServiceURL;
